import {hasRole} from '../../../../utils/hasRole';
import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const FulfilmentitemListComponent = (props) => {

  const {t, fulfillmentStatus, fulfillmentId, fulfillmentCurrency} = props;
  const canWriteFulfillment = hasRole('ROLE_FULFILLMENT_WRITE');
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [fulfilmentitems, setFulfilmentitems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const isParentClosed = fulfillmentStatus?.toUpperCase() === 'CLOSED' || fulfillmentStatus?.toUpperCase() === 'DELETED';
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    const fid = fulfillmentId;
    const query = fid
      ? `?search[fulfillment][operator]=%3D&search[fulfillment][value]=${fid}`
      : '';
    loadLazyTimeout = setTimeout(() => {
      axios.get(process.env.REACT_APP_API_HOST + "/api/v2/fulfillment-item" + query,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          // setTotalRecords(response.data.data.total_item_count);
          setFulfilmentitems(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
      setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {canWriteFulfillment &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  disabled={isParentClosed}
                  onClick={() => {
                    if (entity === 'fulfilmentitem') {
                      history.push('/project/fulfilmentitem/update/' + rowData.id)
                    } else {
                      history.push('/project/' + entity + '/' + action + '/' + id + '?update=fulfilmentitem&fulfilmentitemId=' + rowData.id)
                    }
                  }}/>
        }
        {canWriteFulfillment &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      axios.delete(process.env.REACT_APP_API_HOST + "/api/v2/fulfillment-item/" + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', t('toastDeleteSuccess'));
                          window.App.setState({
                            rerenderFulfilmentitemList: Math.random(),
                            rerenderFulfilmentList: Math.random(),
                            rerenderRetentionList: Math.random()
                          });
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, fulfillmentId, window.App.state.rerenderFulfilmentitemList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={fulfilmentitems} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
      >
        <Column field="name" header={t('columnName')} sortable></Column>
        <Column field="unit_price" header={t('columnNetUnitPrice')} sortable className={"p-text-right"}
                body={(rowData) => window.App.currencyFormatter(fulfillmentCurrency || rowData?.currency || 'HUF', rowData?.unit_price)}
        ></Column>
        <Column field="vat_rate.label" header={t('columnVat')} sortable className={"p-text-right"}
        ></Column>
        <Column field="vat_amount" header={t('columnVatValue')} sortable className={"p-text-right"}
                body={(rowData) => window.App.currencyFormatter(fulfillmentCurrency || rowData?.currency || 'HUF', rowData?.vat_amount)}
        ></Column>
        <Column field="gross_price" header={t('columnGrossValue')} sortable className={"p-text-right"}
                body={(rowData) => window.App.currencyFormatter(fulfillmentCurrency || rowData?.currency || 'HUF', rowData?.gross_amount)}
        ></Column>
        <Column field="is_additional" header={t('columnAdditionalWork')} sortable className={"p-text-right"}
                body={(rowData) => rowData?.is_additional ? props.t('yes') : props.t('no')}
        ></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(FulfilmentitemListComponent);
